@if (selectedSite) {
  <div class="site-selector" data-test="account-picker">
    <mat-form-field class="site-selector__input-container" data-test="account-input-container">
      @if (loading) {
        <mat-progress-spinner mode="indeterminate" diameter="20"></mat-progress-spinner>
      }
      <input
        class="site-selector__input"
        type="text"
        matInput
        #siteInput
        [matAutocomplete]="auto"
        [value]="onFocusName ? '' : selectedSite.name"
        (focus)="onFocus($event)"
        (keyup)="onKeyUp($event)" />
      @if (selectableSites) {
        <mat-icon class="site-selector__icon">keyboard_arrow_down</mat-icon>
      }
    </mat-form-field>
    <mat-autocomplete class="site-selector__autocomplete" #auto="matAutocomplete">
      @for (site of filteredSites; track site) {
        <mat-option class="site-selector__autocomplete-option" [value]="site.name" (click)="onOptionClick(site.id)">
          {{ site.name }}
        </mat-option>
      }
      @if (!loading && showAddButton) {
        <mat-option class="site-selector__autocomplete-option" (click)="addAccount()">
          <mat-icon>add_circle_outline</mat-icon>
          {{ "settings.account.site-selector.create-button" | translate | uppercase }}
        </mat-option>
      }
    </mat-autocomplete>
  </div>
}
